import View from './FormUserBlocked';
import enhancer from './FormUserBlocked.enhancer';

export default enhancer(View);
